import { useEffect } from "react";
import { useErrorsContext } from "components/lookup-tables/contexts/ErrorsContext";
import { useFetchErrors } from "components/lookup-tables/hooks/useLookupTablesAPI";
const ErrorsConsumer = ({
  lutNames = void 0,
  cacheNames = void 0,
  adapterNames = void 0
}) => {
  const { setErrors } = useErrorsContext();
  const { fetchErrors } = useFetchErrors();
  useEffect(() => {
    const interval = setInterval(() => {
      fetchErrors({ lutNames, cacheNames, adapterNames }).then(
        ({ tables, caches, data_adapters }) => setErrors({ lutErrors: tables, cacheErrors: caches, adapterErrors: data_adapters })
      );
    }, 1e3);
    return () => clearInterval(interval);
  }, [lutNames, cacheNames, adapterNames, fetchErrors, setErrors]);
  return null;
};
export default ErrorsConsumer;
